$(document).ready(function () {
  window.navigation.addEventListener('navigate', (event) => {
    const _tooltips = document.getElementsByClassName('tooltip');
    for (const element of _tooltips) {
      element.remove();
    }
  });
});
